import { render, staticRenderFns } from "./jpoLayer.vue?vue&type=template&id=2b23a27e&"
import script from "./jpoLayer.vue?vue&type=script&lang=js&"
export * from "./jpoLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports